import React, { useContext, useCallback } from 'react'
import { IChannel } from 'shared/types/channel'
import AddToButton from './add-to-button'
import ChannelList from './channel-list'
import EmptyCollectionCTA from './empty-collection-cta'
import ModalContext from 'shared/components/context/modal'
import { CollectionContext } from 'shared/components/context/add-to-collections-manager'
import { AddToCollectionPlus, AddToSection, AddToCollectionContainer, AddToCollectionText } from './sc'
import { Grid } from '@giphy/react-components'
import { useChannelWithNormalGifFetch } from 'shared/api/channels'
import { isEmpty } from 'lodash'
import { CollectionStyleContext } from './../context/collection-style-context'

export function flatten(children: IChannel[]) {
    const flat: IChannel[] = [...children]
    children.forEach(channel => {
        if (channel.children) {
            flat.push(...flatten(channel.children))
        }
    })
    return flat
}

const empty = {} as IChannel
type Props = {
    onClickChannel: (channelId: number, searchChannelId: number) => void
    onClickAddTo?: (channelId: number, searchChannelId: number) => void
}

const ChannelsGif = ({ channelId }: { channelId: number }) => {
    const { gif } = useContext(CollectionContext)
    const fetchGifs = useChannelWithNormalGifFetch(channelId, 'gifs')

    return <Grid fetchGifs={fetchGifs} gutter={10} width={gif ? 480 : 968} columns={3} />
}

const AddToCollection = ({ onClickChannel, onClickAddTo }: Props) => {
    const {
        activeChannelId,
        addGifsToCollectionSuccessMessage,
        activeChannelColor,
        gif,
        channels,
        rootChannelId,
    } = useContext(CollectionContext)
    const { selectedChannelIds, showGifsBelow } = useContext(CollectionStyleContext)
    const rootChannel = channels[rootChannelId]
    const { openNewCollectionPanel } = useContext(ModalContext)
    const findChannel = (id: number | undefined) => (id ? channels[id] || empty : empty)
    const activeChannel = findChannel(activeChannelId)

    const CallbackChannelsGif = useCallback(() => {
        return <ChannelsGif channelId={activeChannel.id} />
    }, [activeChannelId, addGifsToCollectionSuccessMessage])

    const showEmptyCta = () => {
        if (!!activeChannel && !isEmpty(activeChannel)) {
            const { has_children, parent } = activeChannel
            if (!has_children && !parent) {
                return true
            } else {
                return false
            }
        }
    }
    return (
        <>
            {!showEmptyCta() ? (
                <>
                    <ChannelList
                        addButton={
                            <AddToButton
                                displayName={activeChannelId ? 'New sub-collection' : 'New collection'}
                                onClick={() =>
                                    openNewCollectionPanel({
                                        parentChannel: activeChannel,
                                        userId: rootChannel.user?.id,
                                        gif,
                                    })
                                }
                                backgroundText={activeChannelId ? '#3e3e3e' : activeChannelColor}
                            />
                        }
                        onClick={(collectionId: number) => {
                            onClickChannel(collectionId, rootChannelId)
                        }}
                        channel={activeChannelId ? activeChannel : rootChannel}
                        isRoot={!activeChannel}
                    />
                    {activeChannelId && !!activeChannel.parent && (
                        <>
                            <AddToSection>
                                <AddToCollectionContainer
                                    onClick={() => onClickAddTo?.(activeChannelId, rootChannelId)}
                                    selected={selectedChannelIds?.includes(activeChannelId)}
                                >
                                    <AddToCollectionPlus />
                                    <AddToCollectionText>
                                        Add to <b>{activeChannel.display_name}</b>
                                    </AddToCollectionText>
                                </AddToCollectionContainer>
                            </AddToSection>
                            {showGifsBelow && <CallbackChannelsGif />}
                        </>
                    )}
                </>
            ) : (
                <EmptyCollectionCTA channel={activeChannel} />
            )}
        </>
    )
}
export default AddToCollection
